import { render, staticRenderFns } from "./CDNDoc2.vue?vue&type=template&id=2c589ae4&scoped=true&"
import script from "./CDNDoc2.vue?vue&type=script&lang=js&"
export * from "./CDNDoc2.vue?vue&type=script&lang=js&"
import style0 from "./CDNDoc2.vue?vue&type=style&index=0&id=2c589ae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c589ae4",
  null
  
)

export default component.exports